import type { ReactNode } from 'react';

// Small pill used for booking/message statuses and the address verdict. Shared so the
// styling lives in one place (BookingsList + BookingDrawer both render it).
export default function Badge({ color, children }: { color: string; children: ReactNode }) {
  return (
    <span
      style={{
        color,
        fontWeight: 600,
        fontSize: 12,
        border: `1px solid ${color}`,
        borderRadius: 999,
        padding: '2px 10px',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
}
